import { useState, useContext, useEffect } from "react";
import "../../styles/index.css";
import "../add-a-user-modal/add-a-user-modal.css";
import "./add-an-estate-user.css";
import AppContext from "../../context/app-context";
import { popup } from "../../vanilla-functions/model";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { MDBDropdown, MDBDropdownMenu, MDBDropdownToggle, MDBDropdownItem } from "mdb-react-ui-kit";

const AddAnEstateUserModal = function ({ display, setAddAnEstateUserModal, getData }) {
  const { backendServer, setIsLoading, validateEmail, updateUsersData, validateMobile, estate } =
    useContext(AppContext);
  const [disableBtn, setDisableBtn] = useState(false);

  const [whatsWrong, setWhatsWrong] = useState("");

  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [mobile, setmobile] = useState("");
  const [email, setemail] = useState("");

  const [role, setRole] = useState("");

  useEffect(() => {
    runValidation();

    if (
      !firstName ||
      !lastName ||
      !email ||
      !validateEmail(email) ||
      !validateMobile(mobile) ||
      !mobile ||
      !role
    )
      setDisableBtn(true);
    else setDisableBtn(false);
  });

  function runValidation() {
    if (!firstName) return setWhatsWrong("First name is requried");
    if (!lastName) return setWhatsWrong("Last name is requried");
    if (!email || !validateEmail(email)) return setWhatsWrong("Email is missing or invalid");
    if (!mobile || !validateMobile(mobile))
      return setWhatsWrong("Mobile Number is missing or invalid");

    if (!role) return setWhatsWrong("Set a staff role for your estate");

    setWhatsWrong("");
  }

  async function addUser() {
    try {
      setIsLoading(true);
      const returned = await (
        await fetch(`${backendServer}/signup/admin`, {
          method: "POST",
          credentials: "include",
          headers: {
            token: localStorage.getItem("emstoken"),
            "content-type": "application/json",
          },
          body: JSON.stringify({
            first_name: firstName,
            last_name: lastName,
            email: email,
            mobile: mobile,
            address: {
              addressString: estate?.address?.addressString,
              geoLocation: {
                coordinates: ["", ""],
              },
              postCode: "000000",
            },
            estateID: estate?._id,
            login_token: {
              token_id: "1",
              token: "1",
            },
            estate_child_roles: [role],
          }),
        })
      ).json();

      if (returned.status === "Internal server error") throw new Error(returned.message);

      setIsLoading(false);
      popup("Staff Added");
      setfirstName("");
      setlastName("");
      setmobile("");
      setemail("");
      setRole("");
      updateUsersData();
      getData();
      setAddAnEstateUserModal(false);
    } catch (err) {
      setIsLoading(false);
      popup("Error creating staff, try again later");
    }
  }

  return (
    <div className="modal-container" style={{ display: `${display ? "flex" : "none"}` }}>
      <div className="modal-body edit-a-staff-modal-body">
        <div className="close-container-modal">
          <AiOutlineCloseCircle
            onClick={() => {
              setAddAnEstateUserModal(false);
            }}
            className="cursor"
            size={20}
            color="#34204C"
          />
        </div>

        <div className="a-staff-modal-cont flex-column align-column-left">
          <div className="flex-row align-row-left">
            <p className="big">Create New Estate Staff</p>
          </div>

          <div className="flex-row">
            <input
              className="in a-a-u-inputs"
              placeholder="First Name"
              type="text"
              value={firstName}
              onChange={(e) => setfirstName(e.target.value)}
            />
            <input
              className="in a-a-u-inputs"
              placeholder="Last Name"
              type="text"
              maxLength="100"
              value={lastName}
              onChange={(e) => setlastName(e.target.value)}
            />
          </div>

          <div className="flex-row">
            <input
              className="in a-a-u-inputs"
              placeholder="Email"
              type="email"
              maxLength="100"
              value={email}
              onChange={(e) => {
                setemail(e.target.value);
              }}
            />
            <input
              className="in a-a-u-inputs"
              placeholder="Mobile"
              type="text"
              value={mobile}
              onChange={(e) => {
                setmobile(e.target.value);
              }}
            />
          </div>

          <div className="flex-row">
            <MDBDropdown id="mdb-dropdown-custom-dropdown">
              <MDBDropdownToggle id="mdb-dropdown-custom-in-dropdown" color="light">
                {role || "Staff Role"}
              </MDBDropdownToggle>

              <MDBDropdownMenu id="estate-staff-add">
                <MDBDropdownItem
                  link
                  href="#Settings"
                  onClick={(e) => {
                    setRole("secretary");
                  }}
                >
                  Estate Secretary
                </MDBDropdownItem>
                <MDBDropdownItem
                  link
                  href="#Settings"
                  onClick={(e) => {
                    setRole("security");
                  }}
                >
                  Estate Security
                </MDBDropdownItem>
                <MDBDropdownItem
                  link
                  href="#Settings"
                  onClick={(e) => {
                    setRole("accountant");
                  }}
                >
                  Estate Accountant
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
            <input
              className="in a-a-u-inputs"
              placeholder=""
              type="FAKE INPUT"
              maxLength="100"
              value={""}
              style={{ opacity: 0 }}
              onChange={() => {}}
            />
          </div>
        </div>

        <div className="flex-column" style={{ paddingBottom: 20, gap: 5 }}>
          <button disabled={disableBtn} onClick={addUser} className="themeBtn a-a-u-btn">
            Create Staff
          </button>
          <p className="redText small">{whatsWrong}</p>
        </div>
      </div>
    </div>
  );
};

export default AddAnEstateUserModal;
